/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findAll3 } from '../fn/hex/find-all-3';
import { FindAll3$Params } from '../fn/hex/find-all-3';
import { findAll4 } from '../fn/hex/find-all-4';
import { FindAll4$Params } from '../fn/hex/find-all-4';
import { getDiagnoses } from '../fn/hex/get-diagnoses';
import { GetDiagnoses$Params } from '../fn/hex/get-diagnoses';
import { HexAdministration } from '../models/hex-administration';
import { HexServingMode } from '../models/hex-serving-mode';
import { SpeciesDiagnosesMappedDto } from '../models/species-diagnoses-mapped-dto';

@Injectable({ providedIn: 'root' })
export class HexService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll3()` */
  static readonly FindAll3Path = '/api/values/hex/serving-mode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll3()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll3$Response(params?: FindAll3$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HexServingMode>>> {
    return findAll3(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll3(params?: FindAll3$Params, context?: HttpContext): Observable<Array<HexServingMode>> {
    return this.findAll3$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HexServingMode>>): Array<HexServingMode> => r.body)
    );
  }

  /** Path part for operation `getDiagnoses()` */
  static readonly GetDiagnosesPath = '/api/values/hex/diagnoses';

  /**
   * Get lists each of species, diagnoses and mappings between.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDiagnoses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDiagnoses$Response(params?: GetDiagnoses$Params, context?: HttpContext): Observable<StrictHttpResponse<SpeciesDiagnosesMappedDto>> {
    return getDiagnoses(this.http, this.rootUrl, params, context);
  }

  /**
   * Get lists each of species, diagnoses and mappings between.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDiagnoses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDiagnoses(params?: GetDiagnoses$Params, context?: HttpContext): Observable<SpeciesDiagnosesMappedDto> {
    return this.getDiagnoses$Response(params, context).pipe(
      map((r: StrictHttpResponse<SpeciesDiagnosesMappedDto>): SpeciesDiagnosesMappedDto => r.body)
    );
  }

  /** Path part for operation `findAll4()` */
  static readonly FindAll4Path = '/api/values/hex/administration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll4()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll4$Response(params?: FindAll4$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HexAdministration>>> {
    return findAll4(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll4(params?: FindAll4$Params, context?: HttpContext): Observable<Array<HexAdministration>> {
    return this.findAll4$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HexAdministration>>): Array<HexAdministration> => r.body)
    );
  }

}
